<template>
    <div>
        <vue-snotify></vue-snotify>
        <div class="col" v-if="ActionData.customer_form && proposal_status == 5">
            <ValidationProvider
                    vid="user_signature"
                    name="Signature"
                    v-slot="{ errors }"
            >
                <b-row class="row-bottom">
                    <b-col sm="12" md="12" class="signature-pad-local">
                        <VueSignaturePad
                                id="signature"
                                width="100%"
                                height="300px"
                                ref="signaturePad"
                                :options="{
                                          onBegin: () => {
                                            $refs.signaturePad.resizeCanvas();
                                          },
                                          onEnd,
                                        }"
                        />
                        <div class="row">
                            <div class="col-3 mt-2">
                                <button class="btn btn-primary" @click="undo">Undo</button>
                            </div>
                        </div>
                        <input type="hidden" v-model="CustomerData.signature"/>
                    </b-col>

                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div v-if="errors[0]" class="msg-fail validation-form-msg">
                    <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                      {{ error }}
                    </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>
        </div>

    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";

    export default {
        data: () => {
            return {
                customer_form:false
            };
        },
        computed: {
            ...mapState("proposal", [
                "ProposerData",
                "VehicleData",
                "CustomerData",
                "ActionData",
                "is_signature_step",
                "proposal_status"
            ]),
        },
        mounted() {

        },
        methods: {
            undo() {
                this.$refs.signaturePad.undoSignature();
                if(this.$refs.signaturePad.isEmpty()){
                    this.$set(this.CustomerData, "signature", '');
                }
            },
            save() {
                const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
                this.$set(this.CustomerData, "signature", data);
            },
            onBegin() {
                //console.log("=== Begin ===");
            },
            onEnd() {
                this.save();
                //console.log("=== End ===");
            },
            change() {
                this.options = {
                    penColor: "#00f",
                };
            },
            resume() {
                this.options = {
                    penColor: "#c0f",
                };
            },
        }
    }
</script>

<style scoped>
    #signature {
        border: solid 1px #4b78be;
    }

</style>